import {
  observable,
  action,
} from 'mobx';
import { teamsAppService } from 'Store/services/index';
import { store } from 'Store/store.index';
import * as APP_CONSTANTS from 'Constants/app.constant';
import circularLoad from 'Utils/CircularLoad.js'
import { USER_SIGN_IN_SUCCESS } from './constants';
import { queryFromTeams } from '@/modules/queryData';
class TeamsAppStore {
  @observable teamsFileData = null
  @observable inTeamsApp = false
  @observable locationSearch = null
  @action initialize() {
    if (!queryFromTeams) return;
    this.inTeamsApp = queryFromTeams;

    this.loading = circularLoad.show({
      width: 72,
      height: 140,
      progress: {
        auto: true,
        max: parseInt(Math.random() * (96 - 80 + 1) + 80, 10)
      },
      line: {
        width: 5,
        color: '#3571DE',
        round: false
      },
      text: {
        fontSize: 12,
        fontFamily: 'Alatsi',
        content: 'Opening Document {progress}%',
      },
      mask: '#ABABAB',
      zIndex: 1000000
    }).onFinish(function () {
      this.hide();
    });

    this.locationSearch = location.search.replace(/ticket=[\w-]*&?/, '').replace(/remember_me=[\w-]*&?/, '').replace(/role=[\w-]*&?/, '').replace(/enterpriseId=[\w-]*&?/, '').replace(/[?&]$/, '');

    store.appStore.addAppEventListener(APP_CONSTANTS.EVENT_USER_INITIALIZE_END, () => {
      if (!store.userStore.hasSignIn) {
        this.loading.show({progress: 100});
        // this.loading.hide();
      }
    });
    store.appStore.addAppEventListener(USER_SIGN_IN_SUCCESS, () => {
      store.appStore.updateShowHomeStart(false);
      const userEnv = store.userStore.userInfo.region;
      const environmentName = store.appStore.environmentName;

      // 当前登录用户不属于当前环境区域，则不允许发起共享，日本区例外（日本区用户region是us，environmentName是jp）
      if (store.userStore.hasSignIn && (!userEnv || userEnv == environmentName || environmentName === 'jp')) {
        teamsAppService.doAutoOpenOnedriveFileByUrlForTeamsApp();
      }
    });

  }
  @action setTeamsFileData(data) {
    this.teamsFileData = data;
  }
}

export default TeamsAppStore;
